import { AppointmentContract } from "../domain/contracts/appointment_contract";
import { AppointmentEntity } from "../domain/entities/appointment_entity";
import { ProductDetailReportEntity } from "../domain/entities/product_detail_report_entity";
import { AppointmentOperationIndexEntity } from "../domain/entities/appointment_operation_index_entity";
import { AppointmentIndexEntity } from "../domain/entities/appointment_index_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n"

export const HttpAppointmentRepository = {
  ...AppointmentContract,
  model: AppointmentEntity,
  model_report: ProductDetailReportEntity,
  model_operation: AppointmentOperationIndexEntity,
  model_index: AppointmentIndexEntity,

  async show(id) {
    const res = await http.get('appointments/' + id);

    return res;
  },

  async download_product_detail_report(id) {
    const res = await http.get('appointments/download_product_details/' + id);

    return res;
  },

  async operation_index(status, filter, m_type) {
    const res = await http.get('appointmentsOperation/' + status + '/' + filter + '/' + m_type);

    return res;
  },

  async set_status(id, data) {
    const res = await http.put('setStatus/' + id, data);

    return res;
  },

  async index(status, origin, type, page, per_page, search, year, sort_by) {
    var sort = ""

    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;
    const res = await http.get('appointmentsby/' + status + '/' + origin + '/' + type + '?page=' + page + '&per_page=' + per_page + (search != "" ? '&search=' + search : "") + (year != null ? "&year=" + year : "") + sort);
    const d2 = new Date((new Date()).toISOString().slice(0, 10));

    for(let i = 0; i < res.data.data.length; i++) {
      res.data.data[i] = res.data.data[i].attributes;
      
      if(origin == 1) res.data.data[i].actions = this.get_actions_national(status, type, res.data.data[i]);
      else res.data.data[i].actions = this.get_actions_international(status, type, res.data.data[i]);

      res.data.data[i].idIndex = res.data.data[i].id;
      res.data.data[i].parameters = res.data.data[i].id;

      res.data.data[i].arrival_date = (new Date(res.data.data[i].arrival_date)).toISOString().slice(0, 10);
      
      if(status == "Pendiente"){ // COLORED DOT
        const d1 = new Date(res.data.data[i].arrival_date);
        if(d1 > d2) res.data.data[i].dotColor = 'blue_dashboard';
        else if(+d1 === +d2) res.data.data[i].dotColor = 'orange';
        else res.data.data[i].dotColor = "red";
      }
    }

    return res;
  },

  get_actions_national(status, type, x) {
    // National Income
    if(status == "Pendiente" && type == "income") {
      return JSON.parse(JSON.stringify([
      {
        name: i18n.t('pendings.preload'),
        icon: {
            color: 'accent',
            icon: 'archive'
        },
        link: (x.status == "Pendiente" || x.status == "En recinto" || x.status == "En rampa" || x.status == "Procesando") ? '/appointment-preload-income/' + x.id + '/national/' + type : null,
        permission: 'appointment.update|detail_appointment.update|n_pending.update'
      },
      {
        name: i18n.t('pendings.edit'),
        icon: {
            color: x.files_status == "COMPLETED" ? 'success2' : x.files_status == "SOME" ? 'warning' : 'accent',
            icon: 'mode_edit'
        },
        link: '/edit-appointment/' + x.id + '/national/' + type,
        permission: 'appointment.update|detail_appointment.update|n_pending.update'
      },
      {
        name: i18n.t('pendings.export_product_detail'),
        icon: {
            color: 'accent',
            icon: 'file_download'
        },
        method: 'downloadProductDetail',
        permission: 'appointment.update|detail_appointment.update|n_pending.update'
      }]));
    }
    // National Outcome
    else if(status == "Pendiente" && type == "outcome") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.preload'),
          icon: {
              color: 'accent',
              icon: 'archive'
          },
          link: ((x.warehouse.picking_required == false && x.status != "Pendiente de salida" && x.status != "Procesando") || (x.already_picked == null && x.warehouse.picking_required == true)) ? '/appointment-preload-outcome/' + x.id + '/national/' + type : null,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('pendings.pickeo'),
          icon: {
              color: 'accent',
              icon: 'qr_code_scanner'
          },
          link: (x.already_picked == null && x.warehouse.picking_required == true) ? '/appointment-picking/' + x.id : null,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: x.files_status == "COMPLETED" ? 'success2' : x.files_status == "SOME" ? 'warning' : 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/national/' + type,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('pendings.export_product_detail'),
          icon: {
              color: 'accent',
              icon: 'file_download'
          },
          method: 'downloadProductDetail',
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        }
      ]));
    }
    // National Income
    else if(status == "Procesadas" && type == "income") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.store'),
          icon: {
              color: 'accent',
              icon: 'gps_fixed'
          },
          link: x.status == "Procesada" ? '/appointment-store-product-income/' + x.id + '/national' : null,
          permission: 'appointment.show|detail_appointment.show'
        },
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: x.files_status == "COMPLETED" ? 'success2' : x.files_status == "SOME" ? 'warning' : 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/national/' + type,
          permission: 'appointment.update|detail_appointment.update'
        },
        {
          name: i18n.t('processed.download_pdf'),
          icon: {
              color: 'accent',
              icon: 'sticky_note_2'
          },
          method: x.status == "Procesada" ? 'downloadSimple' : 'download',
          permission: 'n_pdf.show|n_pdf.index'
        },
        {
          name: i18n.t('processed.export_product_detail'),
          icon: {
              color: 'accent',
              icon: 'file_download'
          },
          method: 'downloadProductDetail',
          permission: 'appointment.update|detail_appointment.update'
        }
      ]));
    }
    // National Outcome
    else if(status == "Procesadas" && type == "outcome") {
      return JSON.parse(JSON.stringify([
        {
          name:i18n.t('pendings.edit'),
          icon: {
              color: 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/national/' + type,
          permission: 'appointment.update|detail_appointment.update'
        },
        {
          name:i18n.t('processed.download_pdf'),
          icon: {
              color: 'accent',
              icon: 'sticky_note_2'
          },
          method: 'download',
          permission: 'n_pdf.show|n_pdf.index' //preguntar por pdf permission
        },
        {
          name:i18n.t('processed.export_product_detail'),
          icon: {
              color: 'accent',
              icon: 'file_download'
          },
          method: 'downloadProductDetail',
          permission: 'appointment.update|detail_appointment.update'
        }
      ]))
    }
  },

  get_actions_international(status, type, x) {
    if(status == "Pendiente" && type == "income") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.preload'),
          icon: {
              color: 'accent',
              icon: 'archive'
          },
          link: (x.status == "Pendiente" || x.status == "En recinto" || x.status == "En rampa" || x.status == "Procesando") ? '/appointment-preload-income/' + x.id + '/international/' + type : null,
          permission: 'appointment.update|detail_appointment.update|i_pending.update'
        },
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/international/' + type,
          permission: 'appointment.update|detail_appointment.update|i_pending.update'
        },
        {
          name: i18n.t('processed.files'),
          icon: {
              color: 'accent',
              icon: 'folder'
          },
          link: '/upload-files-international/' + x.id,
          permission: 'appointment.file|i_pending.file'
        }
      ]))
    }
    else if(status == "Pendiente" && type == "outcome") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.preload'),
          icon: {
              color: 'accent',
              icon: 'archive'
          },
          link: ((x.warehouse.picking_required == false && x.status != "Pendiente de salida") || (x.already_picked == null && x.warehouse.picking_required == true)) ?  '/appointment-preload-outcome/' + x.id + '/international/' + type : null,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('pendings.pickeo'),
          icon: {
              color: 'accent',
              icon: 'qr_code_scanner'
          },
          link: (x.already_picked == null && x.warehouse.picking_required == true) ? '/appointment-picking/' + x.id : null,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/international/' + type,
          permission: 'appointment.update|detail_appointment.update|n_pending.update'
        },
        {
          name: i18n.t('processed.files'),
          icon: {
              color: 'accent',
              icon: 'folder'
          },
          link: '/upload-files-international/' + x.id,
          permission: 'appointment.file|n_pending.file'
        }
      ]))
    }
    else if(status == "Procesadas" && type == "income") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.store'),
          icon: {
              color: 'accent',
              icon: 'gps_fixed'
          },
          link: (x.status == "Procesada" || x.status == "Pendiente Anexo24") ? '/appointment-store-product-income/' + x.id + '/international' : null,
          permission: 'appointment.show|detail_appointment.show'
        },
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/international/' + type,
          permission: 'appointment.update|detail_appointment.update'
        },
        {
          name: i18n.t('processed.files'),
          icon: {
              color: (x.document_management == null || x.document_management == undefined) ? 'accent' : 'success2',
              icon: 'folder'
          },
          link: '/upload-files-international/' + x.id,
          permission: 'appointment.file|n_processed.file'
        }
      ]))
    }
    else if(status == "Procesadas" && type == "outcome") {
      return JSON.parse(JSON.stringify([
        {
          name: i18n.t('pendings.edit'),
          icon: {
              color: 'accent',
              icon: 'mode_edit'
          },
          link: '/edit-appointment/' + x.id + '/international/' + type,
          permission: 'appointment.update|detail_appointment.update'
        },
        {
          name: i18n.t('processed.files'),
          icon: {
              color: (x.document_management == null || x.document_management == undefined) ? 'accent' : 'success2',
              icon: 'folder'
          },
          link: '/upload-files-international/' + x.id,
          permission: 'appointment.file|n_processed.file'
        }
      ]))
    }
  }
};